import React, { FC, useMemo } from 'react';
import { PaymentOption } from '../../../../models/form/paymentOption';
import OptionList from '../optionlist/OptionList';
import { getText } from '../../../../utilities/CultureUtilities';
import { useIntl } from 'react-intl';
import _ from 'lodash';

export interface Props {
  value: Array<string>;
  options: PaymentOption[];
  onChange: (value: string[]) => void;
  multiSelection: boolean | undefined;
  readOnlyMode?: boolean;
  culture?: string;
  fieldId: string;
  fieldProperties: any;
}

const PaymentOptionList: FC<Props> = ({
  value,
  options,
  onChange,
  multiSelection,
  readOnlyMode,
  culture,
  fieldId,
  fieldProperties,
}: Props) => {
  const intl = useIntl();
  const limitsReached = useMemo(() => {
    const limitsReached = {};

    for (const option of options) {
      let limitReached = false;
      if (option.limit && fieldProperties) {
        const claimedProperty =
          _.get(
            fieldProperties.properties.find(
              (p) => p.id == fieldId && p.properties.productId == option.value && p.type == 'claimed',
            ),
            'properties.quantity',
          ) || 0;

        limitReached = _.parseInt(claimedProperty) >= option.limit;
      }

      limitsReached[option.value] = limitReached;
    }

    return limitsReached;
  }, [options, fieldProperties]);

  return (
    <div className="payment-option-list">
      <OptionList
        value={value || []}
        options={options.map((option) => {
          return {
            text: (
              <div className={'d-flex justify-content-between'}>
                <div className="option-name">{getText(option.text, culture)}</div>
                <div className="option-price">{(Number(option.price) / 100).toFixed(2) || '0.00'} $</div>
              </div>
            ),
            description: getText(option.description, culture),
            value: option.value,
            disabled: limitsReached[option.value],
            errorMessage: limitsReached[option.value]
              ? intl.formatMessage(
                  { id: 'fields.fieldErrors.limit' },
                  { quantityLeft: 0, product: getText(option.text, intl.locale) },
                )
              : undefined,
          };
        })}
        multiSelection={multiSelection}
        onChange={onChange}
        readOnlyMode={readOnlyMode}
      ></OptionList>
    </div>
  );
};

export default PaymentOptionList;
